import { render } from "./TopDevices.vue?vue&type=template&id=0f062d62&scoped=true"
import script from "./TopDevices.vue?vue&type=script&lang=js"
export * from "./TopDevices.vue?vue&type=script&lang=js"

import "./TopDevices.vue?vue&type=style&index=0&id=0f062d62&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f062d62"]])

export default __exports__